<template>
  <div class="date-picker ml-0">
    <v-menu
      v-model="date_menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="filterDate"
          :label="dateFilter.title"
          prepend-icon="event"
          readonly
          v-on="on"
          :clearable="!dateFilter.primary"
          hide-details
        ></v-text-field>
      </template>
      <v-card tile class="mx-auto">
        <v-list v-for="(option, index) in options" :key="index">
          <v-list-item @click="setDate(option)">
            <v-list-item-content>
              <v-list-item-title>{{$t('general.'+option)}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <input type="text" :id="`date-picker_${this.dateFilter.attribute}`" style="max-height: 0px">
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment-timezone'
import 'litepicker/dist/css/style.css'
import Litepicker from 'litepicker'
import { generalHelpers } from '@/_helpers'
// import router from '@/router'
import { createWidgetMixin } from 'vue-instantsearch'
import { connectRange } from 'instantsearch.js/es/connectors/'
// import algoliasearch from 'algoliasearch'

export default {
  name: 'AlgoliaDateFilter',
  props: {
    dateFilter: Object,
    index: Number
  },
  mixins: [
    createWidgetMixin({ connector: connectRange })
  ],
  data () {
    return {
      picker: null,
      startDate: null,
      endDate: null,
      date_menu: false,
      options: ['today', 'tomorrow', 'thisWeek', 'thisMonth', 'custom']
    }
  },
  computed: {
    ...mapState(['generalApp']),
    widgetParams () {
      return {
        attribute: this.dateFilter.attribute
        // precision: 1,
        // min: 0,
        // max: 2000000000
      }
    },
    filter () {
      if (this.startDate && this.endDate && this.state !== null) {
        // let start = this.removeTime(this.startDate) // set time of date to 00:00:00
        // let end = this.removeTime(this.endDate) + 86399 // set time for whole end day (00:00:00 - 23:59:59) , 86399 seconds == 23:59:59 hours
        let start = this.removeTimeStart(this.startDate)
        let end = this.removeTimeEnd(this.endDate)
        // start = this.$options.filters.dateToReadableTz(start)
        // end = this.$options.filters.dateToReadableTz(end)
        return this.dateFilter.attribute + ':' + start + ' TO ' + end
      } else {
        return ''
      }
    },
    filterDate: {
      get () {
        // if (this.startDate && this.endDate) {
        //   const readableStart = this.$options.filters.unixDateToReadableShort(this.startDate, this.$i18n.locale)
        //   const readableEnd = this.$options.filters.unixDateToReadableShort(this.endDate, this.$i18n.locale)
        //   if (readableStart === readableEnd) {
        //     return readableStart
        //   } else {
        //     return readableStart + ' - ' + readableEnd
        //   }
        // } else {
        //   return ''
        // }
        if (this.startDate && this.endDate) {
          let start = this.removeTimeStart(this.startDate)
          let end = this.removeTimeEnd(this.endDate)
          let diff = generalHelpers.calculateTimeDifferencesJustNumber(start, end)
          const readableStart = this.$options.filters.dateToReadableTz(this.startDate)
          const readableEnd = this.$options.filters.dateToReadableTz(this.endDate)
          if (diff <= 24) {
            return readableStart
          } else {
            return readableStart + ' - ' + readableEnd
          }
        } else {
          return ''
        }
      },
      set (newValue) {
        // date input field was cleared
        if (newValue === null) {
          this.startDate = null
          this.endDate = null
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setDateFilter: 'setDateFilter',
      clearDateFilter: 'clearDateFilter'
    }),
    setDate (option) {
      let start = null
      let end = null
      switch (option) {
        case 'today':
          start = new Date()
          end = new Date()
          break
        case 'tomorrow':
          let today = new Date()
          let tomorrow = new Date()
          tomorrow.setDate(today.getDate() + 1)
          start = tomorrow
          end = tomorrow
          break
        case 'thisWeek':
          var curr = new Date()
          start = new Date(curr.setDate(curr.getDate() - curr.getDay() + 1))
          end = new Date(curr.setDate(curr.getDate() - curr.getDay() + 7))
          break
        case 'thisMonth':
          let date = new Date(); let y = date.getFullYear(); let m = date.getMonth()
          start = new Date(y, m, 1)
          end = new Date(y, m + 1, 0)
          break
        case 'custom':
          if (this.startDate && this.endDate) {
            this.picker.setDateRange(new Date(this.startDate * 1000), new Date(this.endDate * 1000))
          }
          this.picker.show()
          break
        default:
      }
      this.startDate = start / 1000 | 0
      this.endDate = end / 1000 | 0
      this.date_menu = false
    },
    removeTime (timestamp) {
      let withoutTime = new Date(timestamp * 1000)
      withoutTime.setHours(0, 0, 0, 0)
      withoutTime = withoutTime / 1000 | 0
      return withoutTime
    },
    removeTimeStart (startDate) {
      const timezone = 'Europe/Prague'
      if (!moment.unix(startDate).isValid()) {
        return moment(startDate).tz(timezone).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }).unix()
      }
      return moment.unix(startDate).tz(timezone).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).unix()
    },
    removeTimeEnd (endDate) {
      const timezone = 'Europe/Prague'
      if (!moment.unix(endDate).isValid()) {
        moment(endDate).tz(timezone).set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999
        }).unix()
      }
      return moment.unix(endDate).tz(timezone).set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 999
      }).unix()
    },
    setDeafultDateRange () {
      const weekInMiliseconds = 604800000
      const monthInMiliseconds = 4 * weekInMiliseconds // 4 weeks
      const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime()

      const future = this.dateFilter.default.futureInWeeks * weekInMiliseconds
      const past = (this.dateFilter.default.lengthInMonths * monthInMiliseconds) - future

      this.startDate = (today - past) / 1000 | 0
      this.endDate = (today + future) / 1000 | 0
      this.picker.setDateRange((today - past), (today + future))
      this.setDateFilter({ filter: this.filter, index: this.index })
    }
  },
  watch: {
    picker: {
      deep: true,
      handler (value) {
        if (this.picker.getStartDate() !== null && this.picker.getEndDate() !== null) {
          this.startDate = this.picker.getStartDate() / 1000 | 0
          this.endDate = this.picker.getEndDate() / 1000 | 0
        }
      }
    },
    filter () {
      // let primaryDateObj = null
      if (this.startDate && this.endDate) {
        let refineMin = this.state.range.min
        let refineMax = this.state.range.max
        // if (this.state.range.min < this.removeTime(this.startDate)) {
        //   refineMin = this.removeTime(this.startDate)
        // }
        if (this.state.range.min < this.removeTimeStart(this.startDate)) {
          // refineMin = this.removeTime(this.startDate)
          refineMin = this.removeTimeStart(this.startDate)
        }
        // if (this.state.range.max > (this.removeTime(this.endDate) + 86399)) {
        //   refineMax = this.removeTime(this.endDate) + 86399
        // }
        if (this.state.range.max > this.removeTimeEnd(this.endDate)) {
          // refineMax = this.removeTime(this.endDate) + 86399
          refineMax = this.removeTimeEnd(this.endDate)
        }
        this.state.refine([refineMin, refineMax])
        // primaryDateObj = {
        //   attribute: this.dateFilter.attribute,
        //   start: this.removeTime(this.startDate),
        //   end: this.removeTime(this.endDate) + 86399
        // }
      } else {
        this.state.refine([undefined, undefined])
      }
      this.setDateFilter({ filter: this.filter, index: this.index })
    },
    'generalApp.algoliaDateFilters': {
      deep: true,
      handler (value) {
        if (value[this.index] === undefined) {
          if (this.dateFilter.default) {
            this.setDeafultDateRange()
          } else {
            this.startDate = null
            this.endDate = null
          }
        } else {
          if (value[this.index] != null) {
            const dates = value[this.index].split(':')[1].split(' TO ')
            this.startDate = dates[0]
            this.endDate = dates[1]
          }
        }
      }
    },
    '$i18n.locale': {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (oldVal !== val && this.picker != null) {
          this.picker.setOptions({ lang: val })
        }
      }
    }
    // 'state': {
    //   deep: true,
    //   handler (newVal, oldVal) {
    //     // console.log(this.state)
    //     // this.state.refine.bind(null, item.value)
    //     this.state.defaultRefinement([null, null])
    //     // this.state.refine([null, null])
    //     // if (oldVal === null) {
    //     // }
    //     // defaultRefinement.min
    //   }
    // }
  },
  created () {
    this.clearDateFilter()
  },
  mounted () {
    // date picker initialization
    this.$nextTick(() => {
      this.picker = new Litepicker({
        element: document.getElementById(`date-picker_${this.dateFilter.attribute}`),
        lang: this.$i18n.locale,
        singleMode: false
      })
      this.picker.hide()
      if (this.dateFilter.default) {
        this.setDeafultDateRange()
      }
    })
  }
}
</script>
